var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1402_4437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4695 8.87543H3.87352L5.31859 11.2839C5.35902 11.3513 5.43185 11.3925 5.51044 11.3925H10.8138C10.8818 11.3925 10.946 11.3616 10.9885 11.3085L12.6442 9.23894C12.7614 9.09244 12.6571 8.87543 12.4695 8.87543Z",
    fill: "#5A6068"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36013 0.765625C2.66905 0.765625 2.91948 1.01605 2.91948 1.32497V4.99286L4.24907 8.31684H12.4663C13.1229 8.31684 13.488 9.07638 13.0778 9.58912L11.4221 11.6587C11.2735 11.8445 11.0485 11.9526 10.8106 11.9526H5.50729C5.23222 11.9526 4.97732 11.8083 4.8358 11.5724L3.36768 9.12554L1.87279 5.38833C1.82522 5.2694 1.80078 5.14249 1.80078 5.0144V1.32497C1.80078 1.01605 2.05121 0.765625 2.36013 0.765625ZM4.85829 9.43553L5.69731 10.8339H10.6493L11.768 9.43553H4.85829ZM10.5486 10.9599C10.5485 10.96 10.5487 10.9597 10.5486 10.9599V10.9599Z",
    fill: "#5A6068"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9545 10.832C8.26342 10.832 8.51385 11.0825 8.51385 11.3914V13.6288H11.3106C11.6195 13.6288 11.8699 13.8792 11.8699 14.1881C11.8699 14.497 11.6195 14.7475 11.3106 14.7475H4.59841C4.28949 14.7475 4.03906 14.497 4.03906 14.1881C4.03906 13.8792 4.28949 13.6288 4.59841 13.6288H7.39516V11.3914C7.39516 11.0825 7.64559 10.832 7.9545 10.832Z",
    fill: "#5A6068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36328 5.57812H10.4738C10.9372 5.57812 11.3129 5.95377 11.3129 6.41715Lnan nanL11.3129 6.41715C11.3129 6.88053 10.9372 7.25617 10.4738 7.25617H2.92263L2.36328 5.57812Z",
    fill: "#5A6068"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1402_4437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3521,
    height: 14.3521,
    fill: "white",
    transform: "translate(0.691406 0.808594)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat);
export default __webpack_public_path__ + "static/media/Seat.9d1886f3aa959deafb4e612f1a6dde3e.svg";
export { ForwardRef as ReactComponent };